import React from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

export function EditStateModal({
  isLoadingEditState,
  handleEditHide,
  isEditModal,
  data,
  countryList,
  formikEditState,
  handleOnClickOfEditModalCancelButton,
}) {
  const { state_name } = data;

  return (
    <>
      <Modal
        show={isEditModal}
        onHide={handleEditHide}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title> {`Edit State - ${state_name}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <form
            onSubmit={formikEditState.handleSubmit}
            onReset={formikEditState.handleReset}
          >
            <div className="row">
              <div className="col-md-6 mb-6">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`State Name`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder="State"
                  name="state_name"
                  {...formikEditState.getFieldProps("state_name")}
                />
                {formikEditState.touched.state_name &&
                formikEditState.errors.state_name ? (
                  <div className="invalid-feedback display-block">
                    {formikEditState.errors.state_name}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`State Code`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder={`State Code i.e 'CA'`}
                  name="state_code"
                  {...formikEditState.getFieldProps("state_code")}
                />
                {formikEditState.touched.state_code &&
                formikEditState.errors.state_code ? (
                  <div className="invalid-feedback display-block">
                    {formikEditState.errors.state_code}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 mb-6">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Status`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="status"
                  {...formikEditState.getFieldProps("status")}
                >
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                {formikEditState.touched.status &&
                formikEditState.errors.status ? (
                  <div className="invalid-feedback display-block">
                    {formikEditState.errors.status}
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 mb-6">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Country`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="countryname"
                  {...formikEditState.getFieldProps("countryname")}
                >
                  {countryList.map((country, index) => (
                    <option value={country.name} key={index}>
                      {country.name}
                    </option>
                  ))}
                </select>
                {formikEditState.touched.countryname &&
                formikEditState.errors.countryname ? (
                  <div className="invalid-feedback display-block">
                    {formikEditState.errors.countryname}
                  </div>
                ) : null}
              </div>
            </div>

            <ButtonToolbar className="d-flex justify-content-end button-wrap mb-8">
              <Button
                type="submit"
                disabled={formikEditState.isSubmitting}
                variant="btn btn-success mr-3"
              >
                {`Edit`}
                {isLoadingEditState && (
                  <span className=" mr-3 ml-3 spinner spinner-white"></span>
                )}
              </Button>
              <Button
                type="reset"
                variant="btn btn-light-dark"
                onClick={handleOnClickOfEditModalCancelButton}
              >
                {`Cancel`}
              </Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
